import {
  GET_POINT_EXCHANGE_PRODUCTS,
  ORDER_POINT_EXCHANGE_PRODUCTS,
  GET_MY_POINT_EXCHANGE_PRODUCTS
} from '@/api/graphql/point-exchange'
import { apolloClient } from '@/plugins/apollo'

export default {
  async loadPointExchangeProducts ({ commit }) {
    const res = await apolloClient.query({
      query: GET_POINT_EXCHANGE_PRODUCTS
    })

    const products = res.data.clientPointExchangeProductList
    commit('setPointExchangeProducts', products)
  },
  async orderPointExchangeProducts ({ commit, state, getters }, {
    name, tel, email, address
  }) {
    const cartItems = getters.getPointExchangeCartList
    await apolloClient.mutate({
      mutation: ORDER_POINT_EXCHANGE_PRODUCTS,
      variables: {
        address: (name || tel || email || address)
          ? {
              name,
              tel,
              email,
              address1: address
            }
          : null,
        orders: cartItems.map(i => ({ productId: i.id, quantity: i.quantity })),
        contractId: state.contractId
      }
    })
    commit('emptyPointExchangeCart')
  },
  async myPointExchangeList (context, { apollo }) {
    return new Promise((resolve, reject) => {
      apollo.mutate({
        mutation: GET_MY_POINT_EXCHANGE_PRODUCTS
      }).then(data => {
        context.commit('setPointExchangeHistory', data.data.myPointExchangeList.items)
        resolve(data.data.myPointExchangeList)
      }).catch(error => reject(error))
    })
  }
}
